import { useCallback, useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import { bedStatusAPI } from '../../../../../apis';

// 管理 diagnosis 搜索关键字、debounce、API 请求和下拉选项。
export default function useDiagnosisSearch(wardId) {
  const [diagnosisList, setDiagnosisList] = useState(null);
  const [diagnosisKeyword, setDiagnosisKeyword] = useState(null);

  const loadDiagnosisList = useCallback(async () => {
    if (diagnosisKeyword !== null && typeof diagnosisKeyword === 'string' && diagnosisKeyword.length >= 3) {
      try {
        const getBsDiagnosisList = await bedStatusAPI.getBsDiagnosisList(
          {
            wardId,
            isActive: 1,
            pageNo: 1,
            pageSize: 200,
            keyword: diagnosisKeyword,
          },
          { isHideLoading: true }
        );
        setDiagnosisList(getBsDiagnosisList?.result?.data);
      } catch {}
    }
  }, [diagnosisKeyword, wardId]);

  const handleDiagnosisKeywordChange = useCallback(
    _.debounce((text) => {
      setDiagnosisKeyword(text);
    }, 800),
    []
  );

  // 组件卸载时取消 diagnosis 搜索 debounce。
  useEffect(() => {
    return () => {
      handleDiagnosisKeywordChange.cancel();
    };
  }, [handleDiagnosisKeywordChange]);

  useEffect(() => {
    loadDiagnosisList();
  }, [loadDiagnosisList]);

  const diagnosisOptions = useMemo(() => {
    if (Array.isArray(diagnosisList)) {
      return _.orderBy(
        _.map(diagnosisList, (item) => {
          return { text: item.diagnosis, value: item.diagnosis };
        }),
        'text',
        'asc'
      );
    }
    return [];
  }, [diagnosisList]);

  return {
    diagnosisOptions,
    handleDiagnosisKeywordChange,
  };
}
